
$(document).ready(function () {
    function unreadCheck() {
        setTimeout(function () {
            $('.chat-item.active.unread').removeClass('unread');
            $('.message-cloud.unread').removeClass('unread');
        }, 5000);
    }
    //chat
    if ($('main.chatroom-page').length || $('main.js-for-chat').length) {
        try {
            // Connect to server
            let socket = null;
            let serverUrl = WEBSOCKET_SERVER_URL;

            if (window.MozWebSocket) {
                socket = new MozWebSocket(serverUrl);
            } else if (window.WebSocket) {
                socket = new WebSocket(serverUrl);
            }
            socket.binaryType = 'blob';

            // const onConnect = (data) => {
            //     elClientList.append(new Option(`${data.ip}:${data.port}`, data.port));
            //     elClientCount.textContent = data.clientCount;
            // };

            /**
             * Callen when connected to websocket server.
             * @param {Object} msg
             */
            socket.onopen = (msg) => {
                let payload = {
                    action: 'user',
                    data: USER_ID
                };
                socket.send(JSON.stringify(payload));
                console.log(msg);
                // elStatus.classList.remove('offline');
                // elStatus.classList.add('online');
                // elStatus.innerText = 'connected';
            };

            /**
             * Called when receiving a message from websocket server.
             * @param {Object} msg
             */
            socket.onmessage = (msg) => {
                temp = JSON.parse(msg.data);
                message = JSON.parse(temp.data);
                console.log(message);
                if (message.html && $('.js-message-list').attr('data-id') == message.op_id && $('.js-message-list').attr('data-user') == message.owner_id) {
                    $('.js-message-list').append(message.html);
                    $(".js-message-list").scrollTop($(".js-message-list").prop('scrollHeight'));
                } else if (message.op_id && $('.js-chat-item[data-id=' + message.op_id + ']').length && $('.js-message-list').attr('data-user') == message.owner_id) {
                    $('.js-chat-item[data-id=' + message.op_id + ']').addClass('unread');
                    if (message.text) {
                        $('.js-chat-item[data-id=' + message.op_id + ']').find('.chat-item__text').text(message.text.substring(0, 60));
                    }
                }
            };

            /**
             * Called when disconnected from websocket server.
             * @param {Object} msg
             */
            socket.onclose = (msg) => {
                // elStatus.classList.remove('online');
                // elStatus.classList.add('offline');
                // elStatus.innerText = 'disconnected';
            };
        } catch (e) {
            console.log('websocket error');
        }

        /**
         * Adds event listener to the status indicator.
         */
        // elStatus.addEventListener('click', () => {
        //     socket.close();
        // });

        /**
         * Adds event listener to the send button.
         */
    }

    $('.wrap_container').on('click', '.js-send-message', function () {
        var parent = $(this).closest('.js-send-group');
        console.log(parent);
        if (parent) {
            var text = $(parent).find('[name=text]').val();
            if ($('.chat-item.active').length) {
                var op_id = $('.chat-item.active').attr('data-id');
            } else {
                var op_id = $(this).attr('data-id');
            }
            var url = $(this).attr('data-action');
            var data = {'id': op_id, 'text':text, '_token': CSRF_TOKEN};
            var req = $.ajax({
                method: 'post',
                url: url,
                data: data
            });
            req.done(function(resp) {
                if (resp.success) {
                    $(parent).find('[name=text]').val('');
                }
            })
            req.fail(function(error) {
            });
        }
    });

    $('.js-chat-search').on('keyup', function () {
        var search = $(this).val();
        $('.js-chat-item').each(function (index) {
            if ($(this).attr('data-search').indexOf(search) > -1) {
                $(this).show();
            } else {
                $(this).hide();
            }
        });
    });

    $('.js-chat-item').on('click', function () {
        $('.overlay_page').show();
        $('.loader_wrap').show();

        var op = $(this).attr('data-id');
        var $this = $(this);
        var action = $(this).attr('data-action');

        var req = $.ajax({
            method: 'get',
            url: action,
        });
        req.done(function(resp) {
            if (resp.success) {
                if (resp.html) {
                    $('.js-message-list').html(resp.html);
                    unreadCheck();
                }
                else {
                    $('.js-message-list').html('');
                }
                $('.js-message-list').attr('data-id', op);
                $this.closest('.chat-list').find('.js-chat-item').removeClass('active');
                $this.addClass('active');
                unreadCheck();
            }
        })
        req.always(function(error) {
            $('.overlay_page').hide();
            $('.loader_wrap').hide();
            setTimeout(function(){
                $(".chat-room__container .messages-block").mCustomScrollbar("update");
                $(".chat-room__container .messages-block").mCustomScrollbar("scrollTo", "bottom");
            }, 0);
        });
    })
    function addScrollMessages() {
        $('.chat-room__container .messages-block').mCustomScrollbar({
            theme: "minimal-dark",
        });
    }
    if($(".chat-room__container .messages-block").length) {
        if($(window).width() > 767) {
            addScrollMessages();
        }
        setTimeout(function(){
            $(".chat-room__container .messages-block").mCustomScrollbar("scrollTo", "bottom");
        }, 200);
        $(window).resize(function () {
            if($(window).width() > 767 && !$('messages-block.mCustomScrollbar').length) {
                addScrollMessages();
            }
        });
    }

    $('.open-popup[data-popup=chatRoomSites]').on('click', function() {
        var action = $(this).attr('data-action');
        var req = $.ajax({
            method: 'get',
            url: action,
        });
        req.done(function(resp) {
            if (resp.success) {
                if (resp.html) {
                    $('.js-chatRoomSites').html(resp.html);
                    unreadCheck();
                }
            }
        });
    });
    $('.open-popup[data-popup=chatRoom]').on('click', function() {
        var action = $(this).attr('data-action');
        var req = $.ajax({
            method: 'get',
            url: action,
        });
        req.done(function(resp) {
            if (resp.success) {
                if (resp.html) {
                    $('.js-chatRoom').html(resp.html);
                    unreadCheck();
                }
            }
        });
    });
});
